import React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { AgGridReact } from '@ag-grid-community/react';
import * as _ from 'lodash';
import * as DateUtils from '../../../../HelperMethods/DateUtils';
import { GRID_OPTIONS } from '../../../../HelperMethods/AgGridConstants';

class EngineAllLogsView extends React.Component {
  constructor() {
    super();
    this.state = {
      columnDefs: [
        {
          field: 'createdOn',
          headerName: 'Created On',
          cellRenderer: (params) => {
            return `${DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(params.value)}`;
          },
        },
        {
          field: 'createdBy',
          headerName: 'Run By',
        },
        {
          field: 'status',
          headerName: 'Status',
        },
        {
          field: 'successful',
          headerName: 'Successful',
        },
        {
          field: 'runOn',
          headerName: 'Run On',
          minWidth: 300,
        },
        {
          field: 'runTimeLimit',
          headerName: 'Run Time Limit (sec)',
          maxWidth: 200,
        },
        {
          field: 'runMode',
          headerName: 'Run Mode',
          minWidth: 300,
        },
        {
          field: 'autoPublish',
          headerName: 'Auto Publish',
          maxWidth: 200,
        },
      ],
    };
  }

  render() {
    const { columnDefs } = this.state;
    const { rowData, users, areas } = this.props;
    const usersMap = _.keyBy(users, 'id');
    const areasMap = _.keyBy(areas, 'id');
    rowData.forEach((e) => {
      const {
        timeLimit,
        planningStartDate,
        planningEndDate,
        date: planningDate,
        autoPublish = false,
        currentPlanningStartTime,
        currentPlanningEndTime,
      } = e.data.eventInput;
      e.status = e.data.status;
      if (timeLimit) {
        e.runTimeLimit = parseInt(timeLimit / 1000, 10);
      }
      if (planningStartDate && planningEndDate && planningDate) {
        if (currentPlanningStartTime && currentPlanningEndTime) {
          e.runMode = `Planning from ${DateUtils.getToastrDateText(
            currentPlanningStartTime
          )} to ${DateUtils.getToastrDateText(currentPlanningEndTime)}`;
        } else {
          e.runMode = `Planning for ${DateUtils.getToastrDateText(planningDate)}`;
        }
      } else {
        e.runMode = 'Daily';
      }
      if (e.data.eventInput && e.data.eventInput.userId) {
        const user = usersMap[e.data.eventInput.userId];
        e.runOn = user ? `${user.firstName} ${user.lastName}` : 'Single User';
      } else if (e.data.eventInput && e.data.eventInput.areaIds && e.data.eventInput.areaIds.length > 0) {
        const areaName = e.data.eventInput.areaIds
          .map((id) => _.get(areasMap, `${id}.name`))
          .filter((name) => !!name)
          .join(', ');
        e.runOn = areaName || `${e.data.eventInput.areaIds.length} Area`;
      } else {
        e.runOn = 'Entire Field';
      }
      e.autoPublish = autoPublish;
      // debugger
    });
    return (
      <Container
        fluid
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        className="container-above-task-view-grid"
      >
        <div className="form-header">
          Engine Logs
          <div style={{ position: 'absolute', right: '40px', top: '13px' }}>
            <i
              onClick={() => {
                this.props.goBack();
              }}
              style={{ fontSize: '22px', cursor: 'pointer' }}
              className="fa fa-times-circle"
            />
          </div>
        </div>
        <Grid style={{ marginTop: '0px', height: 'calc(100% - 48px)' }}>
          <Grid.Row>
            <Grid.Column>
              <div className="ag-theme-balham" style={{ height: '100%' }}>
                <AgGridReact
                  {...GRID_OPTIONS}
                  columnDefs={columnDefs}
                  rowData={rowData}
                  onRowDoubleClicked={(e) => {
                    this.props.loadRouteEngineData(e.data);
                  }}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default EngineAllLogsView;
